module.exports = __webpack_public_path__ + "static/Homepage-Hero4-d540a75ac010c1bacf542179ddff0799.jpg";